import { Button } from 'primereact/button'
import React from 'react'
import Spinner from './Spinner'

const buttonTypeClasses = {
  primary: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-primary text-white capitalize border-primary !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-primary'
  },
  gradient: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-gradient text-white capitalize border-[#0070C2] !outline-none !shadow-none !font-[400]',
    hover: '!hover:bg-white hover:text-primary '
  },
  success: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-success text-white capitalize border-success !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-success'
  },
  blue: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-blue text-white capitalize border-blue !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-blue'
  },
  default: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-primary text-white capitalize border-primary !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-primary'
  },
  reset: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 !bg-gray-500 text-white capitalize border-gray-500 !outline-none !shadow-none',
    hover: '!hover:bg-gray-500'
  },
  danger: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-red-500 text-white capitalize border-red-500 !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-red-500'
  }
}

const CustomButton = ({
  label = '',
  className = '',
  type = 'button',
  onClick,
  icon = '',
  buttonType = 'default',
  loading = false,
  disabled = false,
  loadingText = 'Loading',
  LoadingIcon = <Spinner />,
  ...props
}) => {
  const { base, hover } =
    buttonTypeClasses[buttonType] || buttonTypeClasses.default

  // Check if icon is a React component or a string
  const isReactIcon = React.isValidElement(icon)

  // If icon is a React component, render it with the label
  const buttonContent = loading ? (
    <span className='flex gap-2 items-center'>
      {loadingText} {LoadingIcon}
    </span>
  ) : isReactIcon && icon ? (
    <span className='flex gap-2 items-center'>
      {icon}
      {label}
    </span>
  ) : (
    label
  )

  return (
    <Button
      label={buttonContent}
      className={` ${base} ${hover} ${className} `}
      type={type}
      onClick={onClick}
      icon={!isReactIcon ? icon : undefined} // Only pass string icons to PrimeReact
      disabled={disabled || loading}
      pt={{
        root: { className: 'hover:bg-white' },
        label: { className: '!font-[500] whitespace-nowrap' },
        icon: { className: 'mx-2' }
      }}
      {...props}
    />
  )
}

export default CustomButton

